import { useState } from "react";
import { SketchPicker } from "react-color";

const ColorPicker = ({ color, onChange }:any) => {
  const [displayPicker, setDisplayPicker] = useState(false);

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <div
        className="col-md-12 d-flex justify-content-start align-item-center"
        onClick={() => setDisplayPicker(!displayPicker)}
        style={{
          width: "70px",
          height: "25px",
          borderRadius: "4px",
          background: color,
          border: "1px solid #ddd",
          cursor: "pointer",
        }}
      ></div>
      {displayPicker && (
        <div
        className="col-lg-12"
          style={{
            position: "absolute",
            top: "30px",
            left: "0",
            zIndex: 2,
          }}
        >
          <div
            style={{
              position: "fixed",
              top: "0",
              left: "0",
              width: "100vw",
              height: "100vh",
            }}
            onClick={() => setDisplayPicker(false)}
          ></div>
          <SketchPicker color={color} onChange={onChange} />
        </div>
      )}
    </div>
  );
};

export default ColorPicker;
